import Notes from "./utils/Notes";

const ScheduleNotes = ({
  notes,
  setNotes,
  reviewNotes,
  setReviewNotes,
  enableEdit = true,
}) => {
  return (
    <>
      <Notes
        label='Notes/Comments'
        value={notes}
        onChange={(e) => {
          setNotes(e.target.value);
        }}
        enableEdit={enableEdit}
      />
      <br />
      <Notes
        label='Internal Review Notes'
        value={reviewNotes}
        onChange={(e) => {
          setReviewNotes(e.target.value);
        }}
        enableEdit={enableEdit}
      />
    </>
  );
};

export default ScheduleNotes;
